@use '@/styles/tokens' as *;

.card {
  background: $color-white-100;
  border-radius: 16px;
  box-shadow: var(--shadow-surface);
  padding: var(--space-6) var(--space-8);
  border: 1px solid $color-neutral-200;
}
.title {
  margin: 0 0 var(--space-4);
  font-size: 20px;
  font-weight: 500;
  color: $color-neutral-950;
}
.rows {
  margin: 0;
  // One label column shared by every row, sized to the widest label, so every value gets the
  // same width. Sized per row, a value's width was whatever its own label left over, and the same
  // address wrapped at different points under "Billing Address" and "Shipping Address".
  display: grid;
  grid-template-columns: max-content minmax(0, 1fr);
  gap: var(--space-4);
}
.row {
  display: grid;
  grid-column: 1 / -1;
  grid-template-columns: subgrid;
  align-items: start;
}
.label {
  margin: 0;
  font-size: 14px;
  color: $color-neutral-700;
}
.value {
  margin: 0;
  font-size: 14px;
  color: $color-neutral-950;
  text-align: right;
  white-space: pre-line;
  font-weight: 500;
  // A grid item's min-width defaults to its content, so one unbroken token (a long address) pushed
  // the value out of the card instead of wrapping it (121203).
  min-width: 0;
  overflow-wrap: anywhere;
}
// Figma 2704:588862 fades a disabled field's row; the control carries its own disabled style.
.muted .label {
  opacity: 0.5;
}
